<template>
  <div id="adminNav">
    <div class="container">
      <div class="btn-group-vertical mt-4">
        <button
          @click="admin.panel = 'dashboard'"
          :class="{ active: admin.panel === 'dashboard' }"
          type="button"
          class="btn btn-secondary"
        >Dashboard</button>
        <button
          @click="admin.panel = 'design'"
          :class="{ active: admin.panel === 'design' }"
          type="button"
          class="btn btn-secondary"
        >Design</button>
        <button
          @click="admin.panel = 'settings'"
          :class="{ active: admin.panel === 'settings' }"
          type="button"
          class="btn btn-secondary"
        >Settings</button>
      </div><!-- /.btn-group-vertical -->

      <!-- MODULES TABS -->
      <p class="lead mt-4">Modules</p>
      <div class="btn-group-vertical">
        <button
          v-for="module in modules"
          v-bind:key="module.machine_name"
          v-if="dashboard.data.modules[module.machine_name] && dashboard.data.modules[module.machine_name].active"
          @click="admin.panel = module.machine_name"
          :class="{ active: admin.panel === module.machine_name }"
          type="button"
          class="btn btn-secondary"
        >{{ dashboard.data.modules[module.machine_name].title }}</button>
      </div>
    </div><!-- /.container -->
  </div><!-- /#adminNav -->
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState([
        'admin',
        'dashboard',
        'modules'
      ])
    }
  }
</script>

<style scoped>
  .btn-group-vertical {
    width: 100%;
  }
  .btn-group-vertical button {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminNav.vue